module.exports = __webpack_public_path__ + "static/img/ab_main.65eaeef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ab_main.jpg
// module id = iT9i
// module chunks = 1